<template>
<div>
  <div class="overlay"></div>
  <nav class="navbar navbar-expand-lg navbar-light justify-content-between" id="navbartop">
    <div class="container-fluid">
      
      <button type="button" id="sidebarCollapse" class="btn btn-outline-light">
        <i class="navbar-toggler-icon"></i>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="nav navbar-nav ml-auto">
          <li class="nav-item active">
            <a id="profile-name" class="navbar-brand" href="user-profile" >You are Logged In as : {{fullName}}</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
  

</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      fullName: localStorage.getItem('dtp_loggedUser'),
      navData: [
        {
          isNav: true,
          title: 'Dashboard',
          url: 'dashboard',
          icon: 'fas fa-chart-line',
          child: []
        },
        {
          isHeader: true,
          title: 'Transaction',
          child: [
            {
              isNav: true,
              title: 'Request Sample',
              url: 'requestSample',
              icon: 'fas fa-file-signature'
            },
            {
              isNav: true,
              title: 'Approved Quality',
              url: 'approvedQuality',
              icon: 'fas fa-file-invoice'
            },
            {
              isNav: true,
              title: 'Sample Journey',
              url: 'sampleJourney',
              icon: 'fas fa-copy'
            },
          ]
        },
        {
          isHeader: true,
          title: 'Report',
          child: [
            {
              isNav: true,
              title: 'Report Request Sample',
              url: 'rptRequestSample',
              icon: 'fas fa-chart-pie'
            },
          ]
        },
        {
          isHeader: true,
          title: 'Utility',
          child: [
            {
              isNav: true,
              title: 'Mail Management',
              url: 'mailManagement',
              icon: 'fas fa-envelope-open-text'
            },
            {
              isNav: true,
              title: 'Member Management',
              url: 'memberManagement',
              icon: 'fas fa-users-cog'
            },
            {
              isNav: true,
              title: 'User Profile',
              url: 'userProfile',
              icon: 'far fa-id-card'
            },
          ]
        }, 
      ]
    }
  },
  methods: {
    ...mapActions(['appLogout']),
    renderActiveLink(routeName) {
      return (this.$route.name === routeName) ? 'active' : ''
    },
    logout() {
      this.appLogout()
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style scoped>
</style>